module.exports = __webpack_public_path__ + "img/water.82e3f709.png";